import { Box, Typography } from '@mui/material'

import { type InfoChipProps } from './InfoChip.types'

const InfoChip = ({ label, icon, sx }: InfoChipProps) => {
  return (
    <Box
      sx={{
        backgroundColor: '#F5F5F7',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 8px',
        borderRadius: '16px',
        width: 'fit-content',
        ...sx,
      }}
    >
      {icon}
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: '10px',
          color: '#464A54',
        }}
      >
        {label}
      </Typography>
    </Box>
  )
}

export default InfoChip
